import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  FinancialKnowledge,
  ProfilEmprunteurDeplacementTravailEnHauteur,
} from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(
    entity: ProfilEmprunteurDeplacementTravailEnHauteur & {
      profilEmprunteur: any;
    },
    option,
  ) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerId: [entity.ownerId],
        userFirstName: [entity.userFirstName],
        userLastName: [entity.userLastName],
        profilEmprunteur: this.formBuilder.group({
          deplacementKilometrique: [
            entity?.profilEmprunteur?.deplacementKilometrique || null,
            Validators.required,
          ],
          travailEnHauteur: [
            entity?.profilEmprunteur?.travailEnHauteur || null,
            Validators.required,
          ],
        }),
      },
      options,
    );
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
